import styled from '@emotion/styled'

export const DatePickerWrapper = styled.div``
